export default __webpack_public_path__ + "static/media/remove-selected.e40b85f4.svg";